import React from "react";

const TrackSelectors = () => {
  return (
    <React.Fragment>
      {/* Start Track Selectors */}
      <div className="btn__base r3c5">
        <div className="btn">
          <div className="num">1</div>
        </div>
      </div>
      <div className="btn__base r3c6">
        <div className="btn">
          <div className="num">2</div>
        </div>
      </div>
      <div className="btn__base r3c7">
        <div className="btn">
          <div className="num">3</div>
        </div>
      </div>
      <div className="btn__base r3c8">
        <div className="btn">
          <div className="num">4</div>
        </div>
      </div>
      {/* End Track Selectors */}
    </React.Fragment>
  );
};

export default TrackSelectors;
